import { Outlet, Route, Routes } from 'react-router-dom';
import { GuestBalancesTable } from './GuestBalancesTable';
import { useGuestBalancesTableFilter } from './useGuestBalancesTableFilter';

export const GuestBalancesRoutes = ({
  onOpenDeposit,
  onOpenReservation,
  children,
}: {
  onOpenDeposit?: (transactionId: string) => void;
  onOpenReservation?: (reservationId: string) => void;
  children?: React.ReactNode;
}) => {
  return (
    <Routes>
      <Route path="*" element={children ?? <Outlet />}>
        <Route
          index
          element={
            <View
              onOpenDeposit={onOpenDeposit}
              onOpenReservation={onOpenReservation}
            />
          }
        />
        <Route
          path=":occupancyStatus"
          element={
            <View
              onOpenDeposit={onOpenDeposit}
              onOpenReservation={onOpenReservation}
            />
          }
        />
      </Route>
    </Routes>
  );
};

const View = ({
  onOpenDeposit,
  onOpenReservation,
}: {
  onOpenDeposit?: (transactionId: string) => void;
  onOpenReservation?: (reservationId: string) => void;
}) => {
  const { filter } = useGuestBalancesTableFilter();

  return (
    <GuestBalancesTable
      key={`guest-balances-${filter.occupancyStatus}`}
      onOpenDeposit={onOpenDeposit}
      onOpenReservation={onOpenReservation}
    />
  );
};
